/** Design system v1.2 ("Held at home") in the ZenQuip palette + v1.3 pastel accent tokens for JS consumers (Tailwind holds the same values for classes). */
export const TOKENS = {
  colour: {
    teal700: '#1d4ed8', teal600: '#2563eb', teal500: '#3b82f6', teal200: '#93c5fd', teal100: '#dbeafe',
    sage500: '#8b5cf6', sage300: '#ddd6fe', sage200: '#f3e8ff', sage100: '#faf5ff', cream: '#eff6ff', white: '#FFFFFF',
    apricot600: '#e11d48', apricot500: '#fb7185', apricot200: '#fecdd3', apricotInk: '#9f1239',
    wood500: '#C8925E', wood100: '#F4E6D3', woodInk: '#6B4522',
    ink: '#0f172a', inkSoft: '#334155', inkMuted: '#475569',
    progress: '#2BB1A6', progressSoft: '#E3F4F1', progressInk: '#116B63',
    attention: '#E0A526', attentionSoft: '#FFF3D6', attentionInk: '#7A5A0B',
    alert: '#E0603F', alertSoft: '#FBE3E0', alertInk: '#8A3527',
    provider: '#2A7DB5', providerSoft: '#D9EEFA', providerInk: '#1F5F8B',
    // v1.3 pastel accents (fills only; text on them is `ink`).
    lavender50: '#FAF5FF', lavender200: '#E9D5FF', mint50: '#F0FDF4', mint200: '#BBF7D0', peach50: '#FFF1F2', peach200: '#FECDD3',
  },
  motion: { fade: 180, snappy: 300, gentle: 450, sheet: 550 },
  status: {
    draft: { bg: '#e2e8f0', fg: '#334155' },
    generating: { bg: '#fecdd3', fg: '#9f1239' },
    preview_available: { bg: '#dbeafe', fg: '#1d4ed8' },
    payment_pending: { bg: '#fecdd3', fg: '#9f1239' },
    unlocked: { bg: '#2563eb', fg: '#FFFFFF' },
    failed: { bg: '#ffe4e6', fg: '#9f1239' },
  },
  order: {
    paid: { bg: '#dbeafe', fg: '#1d4ed8' },
    pending: { bg: '#fecdd3', fg: '#9f1239' },
    created: { bg: '#fecdd3', fg: '#9f1239' },
    failed: { bg: '#ffe4e6', fg: '#9f1239' },
    cancelled: { bg: '#e2e8f0', fg: '#334155' },
    refunded: { bg: '#e2e8f0', fg: '#334155' },
  },
} as const;

export type ResultBand = 'ok' | 'watch' | 'discuss' | 'na';

/** Dot + label, never colour alone. Labels are the canonical EN band names (i18n keys `band.<key>`). */
export const BAND_STYLE: Record<ResultBand, { label: string; bg: string; fg: string; dot: string }> = {
  ok: { label: 'Meeting milestones', bg: TOKENS.colour.progressSoft, fg: TOKENS.colour.progressInk, dot: TOKENS.colour.progress },
  watch: { label: 'Keep monitoring', bg: TOKENS.colour.attentionSoft, fg: TOKENS.colour.attentionInk, dot: TOKENS.colour.attention },
  discuss: { label: 'Needs attention', bg: TOKENS.colour.providerSoft, fg: TOKENS.colour.providerInk, dot: TOKENS.colour.provider },
  na: { label: 'Not enough answers', bg: '#e2e8f0', fg: TOKENS.colour.inkSoft, dot: TOKENS.colour.teal200 },
};
